const {
  GET_INGREDIENTS_METAOBJECT,
  GET_INGREDIENTS_METAOBJECT_ERROR,
} = require("../actions/types");

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_INGREDIENTS_METAOBJECT:
      return {
        ...state,
        data: payload,
        loading: false,
      };

    case GET_INGREDIENTS_METAOBJECT_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
